module.exports = __webpack_public_path__ + "img/edit.1.d92a9e2.svg";